/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

// Not sure about copyright, so just make a blue italic letter e
export function CareEverywhereLogo() {
  return (
    <span
      style={{
        fontSize: '1.5em',
        color: '#0072C6',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        fontStyle: 'italic',
      }}
    >
      e
    </span>
  );
}
